export const SET_VIDEO_IS_CLICKED = 'SET_VIDEO_IS_CLICKED' as const;
export const CLEAR_VIDEO_IS_CLICKED = 'CLEAR_VIDEO_IS_CLICKED' as const;

export const setVideoIsClicked = (
  videoId: string | null = null,
  rowTitle: string | null = null,
  rowPos: number | null = null,
  rowCol: number | null = null,
) => ({
  type: SET_VIDEO_IS_CLICKED,
  payload: { videoId, rowTitle, rowPos, rowCol },
});

export const clearVideoIsClicked = () => ({
  type: CLEAR_VIDEO_IS_CLICKED,
});
